import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import { store } from './helpers/store';
import { Provider } from 'react-redux';
import { SnackbarProvider } from "notistack";
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
      <SnackbarProvider
          anchorOrigin={{
              vertical: "top",
              horizontal: "center",
          }}
          maxSnack={3}
      >
        <Provider store={store}>
          <App />
        </Provider>
      </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
